import * as Sentry from "@sentry/react";

const SentryInit = () => {
  // Sentry will work only for production mode
  if (process.env.REACT_APP_MODE !== "prod") return;

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration()
      // Sentry.replayIntegration({
      //   maskAllText: false,
      //   blockAllMedia: false
      // }),
      // Sentry.browserProfilingIntegration()
    ],
    tracesSampleRate: 1.0,
    // replaysSessionSampleRate: 0.1,
    // replaysOnErrorSampleRate: 1.0,
    // profilesSampleRate: 1.0,

    beforeSend(event) {
      const frames = event?.exception?.values?.[0]?.stacktrace?.frames || [];
      const message = event?.exception?.values?.[0]?.value || "";

      const blockedDomains = [
        "google-analytics.com",
        "consent.cookiebot.com",
        "bat.bing.com",
        "js.zohocdn.com",
        "googletagmanager.com",
        "chatgpt.com",
        "raven.js",
        "vconsole.min.js",
        "mc.yandex.ru",
        "metrika.yandex.ru",
        "yandex.ru"
      ];

      const blockedMessages = ["UET is not defined"];

      const isFromBlockedDomain = frames.some((frame) =>
        blockedDomains.some((domain) => frame?.filename?.includes(domain))
      );

      const isBlockedMessage = blockedMessages.some((msg) => message.includes(msg));

      if (isFromBlockedDomain || isBlockedMessage) {
        return null;
      }

      return event;
    }
  });
};

SentryInit();
